import React from "react";
import Images from "../Images";
import tw from "tailwind-styled-components";
import LoginRight from "./LoginRight";

function Login() {
    return (
        <div className="flex min-h-screen flex-col lg:flex-row">
            {/* Left Section */}
            <div className="lg:w-1/2 bg-[rgba(0,120,189,1)] text-white lg:p-10 flex flex-col justify-center hidden lg:block ">
                <div className="flex space-x-6 mb-2 mt-6">
                    <Logo src={Images.Logo} alt="logo" />
                </div>
                <div>

                    <h1 className="lg:text-5xl font-bold mb-4">Your partner to</h1>
                    <h1 className="lg:text-5xl font-bold mb-8">Manage Your Properties</h1>

                    <p className="text-sm text-gray-300 mr-9 mb-12 gap-4">
                    Property management software that helps you to list properties, manage tenants, collect payments, and manage staffs with ease, all online.
                    </p>
                    <div className="bg-blue-700 p-4 rounded-lg shadow-lg w-full lg:w-4/5">
                        <h3 className="font-semibold mb-2">I barely had to do anything</h3>
                        <p className="text-sm mb-4 text-gray-300">
                            Love the experience. Got my business set up and all necessary details in about a month, and I barely had to do anything.
                            Definitely recommend!
                        </p>
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <img
                                    src="https://placehold.co/40"
                                    alt="User"
                                    className="w-10 h-10 rounded-full mr-3"
                                />
                                <p className="font-semibold">Catherine Johns Jack</p>
                            </div>
                            <div className="text-yellow-400">
                                ★★★★★
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Section */}
            <div className="lg:w-1/2 flex flex-col justify-center">
                <LoginRight />
            </div>
        </div>
    );
}

const Logo = tw.img`w-20 h-20 object-contain mb-10`;

export default Login;
